var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrashIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 118 160",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "trash-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M110.94,16.56c-2-1.6-3.6-1.7-16.9-1.7H79.54l-.9-2.4c-3-8-5-8.9-19.8-8.9-7.6-.1-11.8.3-13.9,1.2s-3.5,2.4-4.9,5.7l-1.8,4.3H23.34c-14.7,0-14.8,0-17.1,2.3s-3.8,6.6-2.8,8.2c.7,1,110.5,1.2,111.2.2C115.64,24,113.34,18.26,110.94,16.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M56.74,32.63c-26.6,0-52.5-.9-52.9-.3-1.5,2.3,10.6,95.9,14.4,111.3,2.6,10.4,10.2,12.5,20.5,12.7,15.8.3,23.6,0,40.7-.3,9.7-.2,19.5-3.7,21.3-14.2.5-3,14-108.6,13.5-109.6C113.84,31.53,84.94,32.53,56.74,32.63ZM37,143h-.24a2.51,2.51,0,0,1-2.49-2.26l-8.5-87.9a2.5,2.5,0,1,1,5-.48l8.5,87.9A2.51,2.51,0,0,1,37,143Zm24.86-2.49a2.5,2.5,0,0,1-5,0V52.33a2.5,2.5,0,0,1,5,0Zm21.79.24A2.51,2.51,0,0,1,81.15,143h-.24a2.51,2.51,0,0,1-2.25-2.73l8.6-87.9a2.5,2.5,0,0,1,5,.48Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrashIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trash-icon.1fe87c41a5bf73cd96501af426d552ef.svg";